import reducer from "./reducers";

import * as specializationActions from "./actions";

export { specializationActions };

export default reducer;
